// Vagues bornees, dans l'ordre : rend la main quand toutes les taches sont
// retombees. Une tache qui leve n'interrompt pas les suivantes.
export async function runWithConcurrency(taches, limite = 2) {
  if (!Array.isArray(taches) || taches.length === 0) return
  const voies = Math.max(1, Math.min(limite, taches.length))
  let curseur = 0

  const ouvrier = async () => {
    while (curseur < taches.length) {
      const i = curseur
      curseur += 1
      try {
        await taches[i](i)
      } catch {
        /* l'appelant journalise ce qu'il veut */
      }
    }
  }

  await Promise.all(Array.from({ length: voies }, ouvrier))
}
